export const WELCOME = "/";
export const MAP = "/map";
export const THANK_YOU = "/thank-you";
